import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ConfirmedOptionRenderer.scss';

const ConfirmedOptionRenderer = ({ option }) => {
  const { t } = useTranslation();

  return (
    <div>
      {option.confirmed ? (
        <>
          {option.label}
          <span className={styles.confirmedLabel}>{t('components.PaymentDateSelectBoxes.confirmed')}</span>
        </>
      ) : (
        option.label
      )}
    </div>
  );
};

export default ConfirmedOptionRenderer;
